import React from "react";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiSelect from "components/VuiSelect";
import { CURRENCY_OPTIONS } from "constants/CurrencyConstant";

interface Props {
  defaultValue?: string;
  label: string;
  onChange?: (value: string) => void;
}

export const CurrencySelect: React.FC<Props> = ({ defaultValue = "", label, onChange }) => {
  const handleChange = (newValue: { label: string; value: string }) => {
    if (onChange) {
      onChange(newValue.value);
    }
  };

  const formatOptionLabel = ({ value, label }: { value: string; label: string }) => {
    const currency = CURRENCY_OPTIONS.find(c => c.code === value);
    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        {value && (
          <span style={{
            fontSize: '1.2em',
            fontWeight: 'bold',
            minWidth: '24px',
            textAlign: 'center'
          }}>
            {currency?.symbol}
          </span>
        )}
        <span>{label}</span>
      </div>
    );
  };

  return (
    <VuiBox mb={3}>
      <VuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <VuiTypography
          component="label"
          variant="caption"
          fontWeight="bold"
          textTransform="capitalize"
          color="white"
        >
          {label}
        </VuiTypography>
      </VuiBox>
      <VuiSelect
        //@ts-ignore
        defaultValue={
          defaultValue 
            ? {
                label: `${defaultValue} - ${CURRENCY_OPTIONS.find(c => c.code === defaultValue)?.name || defaultValue}`,
                value: defaultValue
              }
            : { label: "Same as Shopify", value: "" }
        }
        options={[
          { value: "", label: "Same as Shopify" },
          ...CURRENCY_OPTIONS.map(currency => ({
            value: currency.code,
            label: `${currency.code} - ${currency.name}`
          }))
        ]}
        onChange={handleChange}
        formatOptionLabel={formatOptionLabel}
        styles={{
          menu: (base: { zIndex: number }) => ({
            ...base,
            zIndex: 99999,
            position: 'absolute'
          })
        }}
      />
    </VuiBox>
  );
};